import { BackgroundImage } from "@/components/backgroundImage"
import { BackPage } from "@/components/backPage";
import { LogoHeader } from "@/components/logoHeader";
import { Select } from "@/components/select"
import { setores } from "@/constants/setores"
import { useCookies } from "@/hooks/useCookies";

function Setor() {
  useCookies()

  return (
    <div className="mx-auto max-w-[500px] min-h-screen px-2 pb-8">
      <LogoHeader />
      <div className="flex flex-col galp-4 px-4">
        <BackgroundImage height="h-[350px]" alt="option-bro.png" src="/assets/option-bro.png" />

        <p className="text-2xl font-bold text-center">
          {setores.pergunta}
        </p>

        <div className="flex flex-col gap-2 px-2 mt-6">
          {setores.options.map((item, idx) => (
            <Select key={idx} idx={idx + 1} id={item.id} label={item.label} />
          ))}
          <BackPage href="/unidade" />
        </div>

      </div>

    </div>
  )
}

export default Setor

